import script from "./VitaMonthChanger.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaMonthChanger.vue?vue&type=script&setup=true&lang=ts"

import "./VitaMonthChanger.vue?vue&type=style&index=0&id=2ebcf19a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebcf19a"]])

export default __exports__